@if (nav.mode() === "organization") {
	<div class="org-switcher">
		<button mat-button [matMenuTriggerFor]="orgMenu" class="switcher-trigger">
			<!--
				One wrapper, deliberately. MatButton collects everything projected
				into it inside a single .mdc-button__label, so a gap set on the
				button never applies between these children — and a bare mat-icon
				is pulled into the button's leading icon slot, which put the
				chevron in front of the logo. Nesting them sidesteps both.
			-->
			<span class="switcher-content">
				<img
					[src]="currentOrganization()?.logo_url || defaultLogo"
					alt=""
					class="org-logo"
					(error)="onLogoError($event)"
				/>
				@if (!nav.railCollapsed()) {
					<span class="org-name">{{ currentOrganization()?.name }}</span>
					<mat-icon class="chevron">expand_more</mat-icon>
				}
			</span>
		</button>
		<mat-menu #orgMenu="matMenu">
			@for (organization of nav.switchableOrganizations(); track organization.id) {
				<a mat-menu-item [routerLink]="['/organizations', organization.id, 'dashboard']">
					{{ organization.name }}
				</a>
			}
			<a mat-menu-item routerLink="/organizations">
				<mat-icon>arrow_back</mat-icon>
				<span>All organizations</span>
			</a>
		</mat-menu>
	</div>
}

<nav class="items" [attr.aria-label]="nav.mode() === 'organization' ? 'Organization' : 'Main'">
	@for (item of items(); track item.label) {
		<a
			class="item"
			[routerLink]="item.route"
			routerLinkActive="active"
			[routerLinkActiveOptions]="{ exact: item.exact ?? false }"
			[matTooltip]="nav.railCollapsed() ? item.label : ''"
			matTooltipPosition="right"
		>
			<mat-icon>{{ item.icon }}</mat-icon>
			@if (!nav.railCollapsed()) {
				<span class="label">{{ item.label }}</span>
			}
		</a>
	}
</nav>
